import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import AppModal from "@/components/AppModal.vue";
import PreLoader from "@/components/PreLoader.vue";
import { useUserStore } from "@/store/user";
import userApi from "@/services/api/userApi";


export default /*#__PURE__*/_defineComponent({
  __name: 'AgreementsModal',
  props: {
  isOpen: { type: Boolean, default: false },
},
  emits: ["close"],
  setup(__props, { expose, emit: emits }) {
  expose();

const props = __props

const userStore = useUserStore();




const agreeTermsOfUse = ref<boolean>(false);
const agreePrivacyPolicy = ref<boolean>(false);
const loading = ref<boolean>(false);
const loadingAgreements = ref<boolean>(false);
const termsId = ref<string>("");
const policyId = ref<string>("");
const backErrorValue = ref<string>("");

const isActualTermsAgreement = computed(() => {
  return userStore.data.termsAgreement?.isActual;
});

const isActualPolicyAgreement = computed(() => {
  return userStore.data.policyAgreement?.isActual;
});

const getTermsOfUseLink = computed(() => {
  return window?.location?.origin + "/terms-of-use";
});

const getPrivacyPolicyLink = computed(() => {
  return window?.location?.origin + "/privacy-policy";
});

const onUpdateTerms = (): void => {
  if (termsId.value) {
    loading.value = true;
    const payload = { termsId: termsId.value, policyId: policyId.value };
    if (isActualTermsAgreement.value) {
      delete payload.termsId;
    }
    if (isActualPolicyAgreement.value) {
      delete payload.policyId;
    }
    userStore
      .updateProfile(payload)
      .then(() => {
        emits("close");
      })
      .catch((err) => {
        if (err.response.data?.error === "ValidationExceptions") {
          backErrorValue.value = err.response.data?.messages[0];
        } else {
          backErrorValue.value = err.response.data?.message;
        }
      })
      .finally(() => (loading.value = false));
  }
};

const main = () => {
  loadingAgreements.value = true;
  Promise.all([
    userApi.getTermsAndPolicy({ type: "termsOfUse" }),
    userApi.getTermsAndPolicy({ type: "privacyPolicy" }),
  ])
    .then((value) => {
      if (value[0]?.data.data?._id) {
        termsId.value = value[0]?.data.data?._id;
      }
      if (value[1]?.data.data?._id) {
        policyId.value = value[1]?.data.data?._id;
      }
    })
    .finally(() => (loadingAgreements.value = false));
};

main();

const __returned__ = { userStore, emits, props, agreeTermsOfUse, agreePrivacyPolicy, loading, loadingAgreements, termsId, policyId, backErrorValue, isActualTermsAgreement, isActualPolicyAgreement, getTermsOfUseLink, getPrivacyPolicyLink, onUpdateTerms, main, computed, ref, AppModal, PreLoader, useUserStore, userApi }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})